import styled from 'styled-components';
import MedicalInfoContent from '@/components/medicalInfo/MedicalContent';
import Footer from '@/components/common/Footer';
import WarningExpired from '@/components/common/WarningExpired';
import useGetGlobalStatus from '@/hooks/useGetGlobalStatus';
import UpdateBanner from '@/components/common/UpdateBanner';

function Medical() {
  const { isExpiryWarning, globalStatus } = useGetGlobalStatus();

  return (
    <Container>
      <UpdateBanner />
      {isExpiryWarning && (
        <WarningExpired expiryDate={globalStatus?.promotionExpiryDate} />
      )}
      <MedicalInfoContent />
      <Footer />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 1080px;
  height: 100vh;
  flex: 1;
  overflow-y: scroll;
  background-color: ${(props) => props.theme.blueColors.scale3};
`;

export default Medical;
